export const API_BASE_URL = "https://www.eatbids.com/api/";

// export const API_BASE_URL = "http://34.130.152.211/api/";

export const API_AUTH = "YWRtaW5hcGk6RGVtb0AyMDIz";
export const MAX_RESULTS = 20;
export const GOOGLE_MAP_API_KEY = "AIzaSyCq7eDtUpBkbxPk6RxhOb6MBplxWiNC0Ys";

export const IMG_URL = "https://www.eatbids.com/api/uploads/";

const currentDate = new Date();
const futureDate = new Date(currentDate);
futureDate.setDate(currentDate.getDate() + 2);
export const FUTURE_DATE = futureDate.toISOString().slice(0, 16);
